export const RUNNER_STATUS = {
  FAILED: "failed",
  START: "start",
  SUCCESS: "complete",
  HASRESULT: "1result",
};

// buildings types
export const CAR_PARKING_TYPE = "carparking";
export const OFFICE_TYPE = "office";
export const DOCKING_AREA_TYPE = "dockingArea";
export const CAR_PARKING_AREA_TYPE = "carparking";

//connections types
export const ADJACENT_TYPE = "adjacent";
export const TRUCK_ROUTE_TYPE = "truckroute";
export const CAR_ROUTE_TYPE = "road";
export const OUTLINE_ROUTE_TYPE = "routeOutline";

export const PARKING_SLOT_AREA_FACTOR = 19.2;

// maximum ratio (in %) of total building area to property area
export const AREA_RATIO = 85;

/* max. Area for Office Building == 1458 m2 */
export const MAX_AREA_OFFICE = 1458;

/* max. Area for Production Building, Logistic Building, Warehouse == 12.600 m2 */
export const MAX_AREA_BUILDINGS = 12600;

/* min. limit of the "max. Construction Height [m]" to 7 [m] */
export const MIN_CONSTRUCTION_HEIGHT = 7;

// validations of area of ​​docking stations based on m in the corresponding ton
export const TRUCK_REQUIREMENT_FACTOR_1 = {
  3.5: 15.4,
  7.5: 18.7,
  18: 22.68,
  40: 38,
};

//validation of Docking Station Area fitting within Building Width
export const TRUCK_REQUIREMENT__FACTOR_2 = {
  3.5: 2.4,
  7.5: 2.5,
  18: 2.5,
  40: 3.5,
};

export const LOCAL_STORAGE_KEYS = {
  showBaseBuildings: "MM_showBaseBuildings",
};

export const zIndexes = {
  nav_header: 10,
  notification: 6,
  activity_sidebar: 5,
  loader: 2,
  first_level: 1,
};

export const APPS = {
  MEMBERSHIP: "MEMBERSHIP",
  LIBRARY: "LIBRARY",
  LAYOUT: "LAYOUT",
  MASTER: "MASTER",
  BUILDING: "BUILDING",
  ORBIT: "ORBIT",
};

export const APPS_TITLE = {
  MEMBERSHIP: "Membership",
  LIBRARY: "Library",
  LAYOUT: "Layout.Maker",
  MASTER: "Master.Maker",
  BUILDING: "Building.Maker",
  ORBIT: "Orbit",
};

export const ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  EDITOR: "editor",
  VIEWER: "viewer",
};

export const DEV_PROJECT_IDs = [
  "iQD75JyNdWqabo10Woi4",
  "lcVGJ6wvEeQoOIpj7bob",
  "zRwHnwLbwpWpNBbDVtFS",
];

export const PROD_PROJECT_IDs = [
  'zdJznhL1HjNH3hc5sdtD',
  'HDjpgXo5Yxf6gh3mBrws',
  'bDPj790uH3xR9AVwGGdw'
];

export const DEV_ROUTE_COORDINATES_1 = [
  [14.304014667587708, 48.28936402265465],
  [
    11.092738062143326,
    46.118641242937116 /* 11.09370851771746, 46.11861665338216 */,
  ],
];

export const DEV_ROUTE_COORDINATES_2 = [
  [14.304014667587708, 48.28936402265465],
  [
    13.686670884490013,
    51.07385113968675 /* 13.688259862506612, 51.0749929334078 */,
  ],
];

export const DEV_ROUTE_COORDINATES_3 = [
  [
    11.092738062143326,
    46.118641242937116 /* 11.09370851771746, 46.11861665338216 */,
  ],
  [
    13.686670884490013,
    51.07385113968675 /* 13.688259862506612, 51.0749929334078 */,
  ],
];

export const DEV_OUTLINEs = {
  iQD75JyNdWqabo10Woi4: {
    area: 30008.35,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[14.30240347981453,48.28835582945999],[14.305116534233093,48.28837679960799]]},"properties":{"id":"942904977e46285afe28b4fd5e4da25e_0","lineName":"ab"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 0,
    locationGeodata:
      '{"id":"address.4818838761656516","type":"Feature","place_type":["address"],"relevance":0.973906,"properties":{"accuracy":"rooftop","mapbox_id":"dXJuOm1ieGFkcjo5OGRlNjkxYy1hYTk4LTRiNjQtYjdlMi0zYWU4NDA5ZmJkN2Q"},"text_de-DE":"Kraußstraße","language_de-DE":"de","place_name_de-DE":"Kraußstraße 7, 4020 Linz, Österreich","text":"Kraußstraße","language":"de","place_name":"Kraußstraße 7, 4020 Linz, Österreich","center":[14.303613,48.288695],"geometry":{"type":"Point","coordinates":[14.303613,48.288695]},"address":"7","context":[{"id":"postcode.5262861","mapbox_id":"dXJuOm1ieHBsYzpVRTRO","text_de-DE":"4020","language_de-DE":"de","text":"4020","language":"de"},{"id":"locality.57444877","mapbox_id":"dXJuOm1ieHBsYzpBMnlLRFE","wikidata":"Q652758","text_de-DE":"Lustenau","language_de-DE":"de","text":"Lustenau","language":"de"},{"id":"place.7882765","mapbox_id":"dXJuOm1ieHBsYzplRWdO","wikidata":"Q41329","text_de-DE":"Linz","language_de-DE":"de","text":"Linz","language":"de"},{"id":"region.41997","mapbox_id":"dXJuOm1ieHBsYzpwQTA","wikidata":"Q41967","short_code":"AT-4","text_de-DE":"Oberösterreich","language_de-DE":"de","text":"Oberösterreich","language":"de"},{"id":"country.8717","mapbox_id":"dXJuOm1ieHBsYzpJZzA","wikidata":"Q40","short_code":"at","text_de-DE":"Österreich","language_de-DE":"de","text":"Österreich","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 48.28936402265465,
      _longitude: 14.304014667587708,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 32394.59,
    perimeter: 812.93,
    location: "Kraußstraße 7, 4020 Linz, Austria",
    maxConstrHeight: 12,
    geodata:
      '{"id":"942904977e46285afe28b4fd5e4da25e","type":"Feature","properties":{},"geometry":{"coordinates":[[[14.302403413159453,48.28835600966278],[14.305116444313569,48.28837658176457],[14.30520919751541,48.28834058058092],[14.305710945783915,48.288878809028404],[14.304954126209395,48.29038746472838],[14.304889349996103,48.29038419634573],[14.304930937908978,48.29029489384985],[14.303647851951183,48.28971375061178],[14.303562828182152,48.28968803615669],[14.303740605153024,48.28949260587285],[14.3032691097101,48.28932288949338],[14.30318408594104,48.28923031668501],[14.303068144438782,48.289153172549874],[14.303052685572169,48.28904517056486],[14.302929014636078,48.28903488464951],[14.302496166361237,48.28884973782084],[14.30251935466174,48.28868516229841],[14.302349307124729,48.288633732339036],[14.302318389391502,48.28834058058092],[14.302403413159453,48.28835600966278]]],"type":"Polygon"}}',
  },
  lcVGJ6wvEeQoOIpj7bob: {
    area: 24204.72,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[11.093128994107246,46.11815923811119],[11.092738062143326,46.118641242937116]]},"properties":{"id":"0f53ee7eb284fbd77687b1d664336a9b_3","lineName":"de"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 3,
    locationGeodata:
      '{"id":"address.8968172934054876","type":"Feature","place_type":["address"],"relevance":0.740247,"properties":{"accuracy":"street","mapbox_id":"dXJuOm1ieGFkci1zdHI6OTc5NjcxNDMtMWI3ZS00MDIwLWI4MWMtODMyYTA2OTM3M2Uz"},"text_de-DE":"Via Linz","place_name_de-DE":"Via Linz, 38121 Trient Trentino, Italien","text":"Via Linz","place_name":"Via Linz, 38121 Trient Trentino, Italien","matching_place_name":"Via Linz, 38121 Trient TN, Italy","center":[11.096826,46.118278],"geometry":{"type":"Point","coordinates":[11.096826,46.118278]},"context":[{"id":"postcode.20082288","mapbox_id":"dXJuOm1ieHBsYzpBVEp1Y0E","text_de-DE":"38121","text":"38121"},{"id":"locality.288418416","mapbox_id":"dXJuOm1ieHBsYzpFVERxY0E","text_de-DE":"Località Produttiva I","text":"Località Produttiva I"},{"id":"place.59394160","mapbox_id":"dXJuOm1ieHBsYzpBNHBJY0E","wikidata":"Q3376","text_de-DE":"Trient","language_de-DE":"de","text":"Trient","language":"de"},{"id":"region.631920","mapbox_id":"dXJuOm1ieHBsYzpDYVJ3","wikidata":"Q16289","short_code":"IT-TN","text_de-DE":"Trentino","language_de-DE":"de","text":"Trentino","language":"de"},{"id":"country.8816","mapbox_id":"dXJuOm1ieHBsYzpJbkE","wikidata":"Q38","short_code":"it","text_de-DE":"Italien","language_de-DE":"de","text":"Italien","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 46.11861665338216,
      _longitude: 11.09370851771746,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 26155.75,
    perimeter: 662.34,
    location: "Via Monaco 2, 38121 Trento Trentino, Italy",
    maxConstrHeight: 12,
    geodata:
      '{"id":"0f53ee7eb284fbd77687b1d664336a9b","type":"Feature","properties":{},"geometry":{"coordinates":[[[11.093826988302851,46.11967977419428],[11.095088539937677,46.11813059999554],[11.093609258579079,46.11755353257004],[11.093128972422427,46.11815944761534],[11.092738339682754,46.11864107182643],[11.092328495497242,46.11916930613259],[11.093826988302851,46.11967977419428]]],"type":"Polygon"}}',
  },
  zRwHnwLbwpWpNBbDVtFS: {
    area: 39248.32,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[13.686670884490013,51.07385113968675],[13.689892888069153,51.073823332547505]]},"properties":{"id":"66ba1618cc30a31f3f297b0628bc5b85_1","lineName":"bc"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 1,
    locationGeodata:
      '{"id":"address.3932535906727092","type":"Feature","place_type":["address"],"relevance":0.990889,"properties":{"accuracy":"rooftop","mapbox_id":"dXJuOm1ieGFkcjphYzMyM2E1MS0xNTJhLTQ4NjktYjhlMC1kMDRmNWVkY2E0NzM"},"text_de-DE":"Overbeckstraße","language_de-DE":"de","place_name_de-DE":"Overbeckstraße 44, 01139 Dresden, Deutschland","text":"Overbeckstraße","language":"de","place_name":"Overbeckstraße 44, 01139 Dresden, Deutschland","matching_place_name":"Overbeckstraße 44, 01139 Dresden, Germany","center":[13.687178,51.07393],"geometry":{"type":"Point","coordinates":[13.687178,51.07393]},"address":"44","context":[{"id":"postcode.77370","mapbox_id":"dXJuOm1ieHBsYzpBUzQ2","text_de-DE":"01139","language_de-DE":"de","text":"01139","language":"de"},{"id":"locality.213723706","mapbox_id":"dXJuOm1ieHBsYzpETDBxT2c","wikidata":"Q8942","text_de-DE":"Mickten","language_de-DE":"de","text":"Mickten","language":"de"},{"id":"place.16746554","mapbox_id":"dXJuOm1ieHBsYzovNGc2","wikidata":"Q1731","text_de-DE":"Dresden","language_de-DE":"de","text":"Dresden","language":"de"},{"id":"region.74810","mapbox_id":"dXJuOm1ieHBsYzpBU1E2","wikidata":"Q1202","short_code":"DE-SN","text_de-DE":"Sachsen","language_de-DE":"de","text":"Sachsen","language":"de"},{"id":"country.8762","mapbox_id":"dXJuOm1ieHBsYzpJam8","wikidata":"Q183","short_code":"de","text_de-DE":"Deutschland","language_de-DE":"de","text":"Deutschland","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 51.0749929334078,
      _longitude: 13.688259862506612,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 42106.05,
    perimeter: 965.19,
    location: "Zur Tiefgarage, 01139 Dresden, Germany",
    maxConstrHeight: 16,
    geodata:
      '{"id":"66ba1618cc30a31f3f297b0628bc5b85","type":"Feature","properties":{},"geometry":{"coordinates":[[[13.686614133428463,51.07615769535704],[13.686671101003753,51.0738510450835],[13.689892932130533,51.073823205494676],[13.689905591584761,51.07499643079419],[13.68853204079025,51.075000407778504],[13.68806680582854,51.07503023156097],[13.688024080162613,51.07616266132093],[13.686614133428463,51.07615769535704]]],"type":"Polygon"}}',
  },
};

export const PROD_OUTLINEs = {
  zdJznhL1HjNH3hc5sdtD: {
    area: 30008.35,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[14.30240347981453,48.28835582945999],[14.305116534233093,48.28837679960799]]},"properties":{"id":"942904977e46285afe28b4fd5e4da25e_0","lineName":"ab"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 0,
    locationGeodata:
      '{"id":"address.4818838761656516","type":"Feature","place_type":["address"],"relevance":0.973906,"properties":{"accuracy":"rooftop","mapbox_id":"dXJuOm1ieGFkcjo5OGRlNjkxYy1hYTk4LTRiNjQtYjdlMi0zYWU4NDA5ZmJkN2Q"},"text_de-DE":"Kraußstraße","language_de-DE":"de","place_name_de-DE":"Kraußstraße 7, 4020 Linz, Österreich","text":"Kraußstraße","language":"de","place_name":"Kraußstraße 7, 4020 Linz, Österreich","center":[14.303613,48.288695],"geometry":{"type":"Point","coordinates":[14.303613,48.288695]},"address":"7","context":[{"id":"postcode.5262861","mapbox_id":"dXJuOm1ieHBsYzpVRTRO","text_de-DE":"4020","language_de-DE":"de","text":"4020","language":"de"},{"id":"locality.57444877","mapbox_id":"dXJuOm1ieHBsYzpBMnlLRFE","wikidata":"Q652758","text_de-DE":"Lustenau","language_de-DE":"de","text":"Lustenau","language":"de"},{"id":"place.7882765","mapbox_id":"dXJuOm1ieHBsYzplRWdO","wikidata":"Q41329","text_de-DE":"Linz","language_de-DE":"de","text":"Linz","language":"de"},{"id":"region.41997","mapbox_id":"dXJuOm1ieHBsYzpwQTA","wikidata":"Q41967","short_code":"AT-4","text_de-DE":"Oberösterreich","language_de-DE":"de","text":"Oberösterreich","language":"de"},{"id":"country.8717","mapbox_id":"dXJuOm1ieHBsYzpJZzA","wikidata":"Q40","short_code":"at","text_de-DE":"Österreich","language_de-DE":"de","text":"Österreich","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 48.28936402265465,
      _longitude: 14.304014667587708,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 32394.59,
    perimeter: 812.93,
    location: "Kraußstraße 7, 4020 Linz, Austria",
    maxConstrHeight: 12,
    geodata:
      '{"id":"942904977e46285afe28b4fd5e4da25e","type":"Feature","properties":{},"geometry":{"coordinates":[[[14.302403413159453,48.28835600966278],[14.305116444313569,48.28837658176457],[14.30520919751541,48.28834058058092],[14.305710945783915,48.288878809028404],[14.304954126209395,48.29038746472838],[14.304889349996103,48.29038419634573],[14.304930937908978,48.29029489384985],[14.303647851951183,48.28971375061178],[14.303562828182152,48.28968803615669],[14.303740605153024,48.28949260587285],[14.3032691097101,48.28932288949338],[14.30318408594104,48.28923031668501],[14.303068144438782,48.289153172549874],[14.303052685572169,48.28904517056486],[14.302929014636078,48.28903488464951],[14.302496166361237,48.28884973782084],[14.30251935466174,48.28868516229841],[14.302349307124729,48.288633732339036],[14.302318389391502,48.28834058058092],[14.302403413159453,48.28835600966278]]],"type":"Polygon"}}',
  },
  HDjpgXo5Yxf6gh3mBrws: {
    area: 24204.72,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[11.093128994107246,46.11815923811119],[11.092738062143326,46.118641242937116]]},"properties":{"id":"0f53ee7eb284fbd77687b1d664336a9b_3","lineName":"de"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 3,
    locationGeodata:
      '{"id":"address.8968172934054876","type":"Feature","place_type":["address"],"relevance":0.740247,"properties":{"accuracy":"street","mapbox_id":"dXJuOm1ieGFkci1zdHI6OTc5NjcxNDMtMWI3ZS00MDIwLWI4MWMtODMyYTA2OTM3M2Uz"},"text_de-DE":"Via Linz","place_name_de-DE":"Via Linz, 38121 Trient Trentino, Italien","text":"Via Linz","place_name":"Via Linz, 38121 Trient Trentino, Italien","matching_place_name":"Via Linz, 38121 Trient TN, Italy","center":[11.096826,46.118278],"geometry":{"type":"Point","coordinates":[11.096826,46.118278]},"context":[{"id":"postcode.20082288","mapbox_id":"dXJuOm1ieHBsYzpBVEp1Y0E","text_de-DE":"38121","text":"38121"},{"id":"locality.288418416","mapbox_id":"dXJuOm1ieHBsYzpFVERxY0E","text_de-DE":"Località Produttiva I","text":"Località Produttiva I"},{"id":"place.59394160","mapbox_id":"dXJuOm1ieHBsYzpBNHBJY0E","wikidata":"Q3376","text_de-DE":"Trient","language_de-DE":"de","text":"Trient","language":"de"},{"id":"region.631920","mapbox_id":"dXJuOm1ieHBsYzpDYVJ3","wikidata":"Q16289","short_code":"IT-TN","text_de-DE":"Trentino","language_de-DE":"de","text":"Trentino","language":"de"},{"id":"country.8816","mapbox_id":"dXJuOm1ieHBsYzpJbkE","wikidata":"Q38","short_code":"it","text_de-DE":"Italien","language_de-DE":"de","text":"Italien","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 46.11861665338216,
      _longitude: 11.09370851771746,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 26155.75,
    perimeter: 662.34,
    location: "Via Monaco 2, 38121 Trento Trentino, Italy",
    maxConstrHeight: 12,
    geodata:
      '{"id":"0f53ee7eb284fbd77687b1d664336a9b","type":"Feature","properties":{},"geometry":{"coordinates":[[[11.093826988302851,46.11967977419428],[11.095088539937677,46.11813059999554],[11.093609258579079,46.11755353257004],[11.093128972422427,46.11815944761534],[11.092738339682754,46.11864107182643],[11.092328495497242,46.11916930613259],[11.093826988302851,46.11967977419428]]],"type":"Polygon"}}',
  },
  bDPj790uH3xR9AVwGGdw: {
    area: 39248.32,
    siteSource: "HAND_DRAWN",
    access1:
      '{"type":"Feature","state":{},"geometry":{"type":"LineString","coordinates":[[13.686670884490013,51.07385113968675],[13.689892888069153,51.073823332547505]]},"properties":{"id":"66ba1618cc30a31f3f297b0628bc5b85_1","lineName":"bc"},"layer":{"id":"edges-layer","type":"line","source":"edges","layout":{"line-join":"round","line-cap":"round"},"paint":{"line-color":{"r":0.9372549019607843,"g":0.6352941176470588,"b":0.11764705882352941,"a":1},"line-width":8,"line-opacity":1}},"source":"edges"}',
    entrySide: 1,
    locationGeodata:
      '{"id":"address.3932535906727092","type":"Feature","place_type":["address"],"relevance":0.990889,"properties":{"accuracy":"rooftop","mapbox_id":"dXJuOm1ieGFkcjphYzMyM2E1MS0xNTJhLTQ4NjktYjhlMC1kMDRmNWVkY2E0NzM"},"text_de-DE":"Overbeckstraße","language_de-DE":"de","place_name_de-DE":"Overbeckstraße 44, 01139 Dresden, Deutschland","text":"Overbeckstraße","language":"de","place_name":"Overbeckstraße 44, 01139 Dresden, Deutschland","matching_place_name":"Overbeckstraße 44, 01139 Dresden, Germany","center":[13.687178,51.07393],"geometry":{"type":"Point","coordinates":[13.687178,51.07393]},"address":"44","context":[{"id":"postcode.77370","mapbox_id":"dXJuOm1ieHBsYzpBUzQ2","text_de-DE":"01139","language_de-DE":"de","text":"01139","language":"de"},{"id":"locality.213723706","mapbox_id":"dXJuOm1ieHBsYzpETDBxT2c","wikidata":"Q8942","text_de-DE":"Mickten","language_de-DE":"de","text":"Mickten","language":"de"},{"id":"place.16746554","mapbox_id":"dXJuOm1ieHBsYzovNGc2","wikidata":"Q1731","text_de-DE":"Dresden","language_de-DE":"de","text":"Dresden","language":"de"},{"id":"region.74810","mapbox_id":"dXJuOm1ieHBsYzpBU1E2","wikidata":"Q1202","short_code":"DE-SN","text_de-DE":"Sachsen","language_de-DE":"de","text":"Sachsen","language":"de"},{"id":"country.8762","mapbox_id":"dXJuOm1ieHBsYzpJam8","wikidata":"Q183","short_code":"de","text_de-DE":"Deutschland","language_de-DE":"de","text":"Deutschland","language":"de"}],"_source":"mapbox"}',
    coordinates: {
      _latitude: 51.0749929334078,
      _longitude: 13.688259862506612,
    },
    minBorderDistance: 3,
    buildingDensity: 0,
    propertyArea: 42106.05,
    perimeter: 965.19,
    location: "Zur Tiefgarage, 01139 Dresden, Germany",
    maxConstrHeight: 16,
    geodata:
      '{"id":"66ba1618cc30a31f3f297b0628bc5b85","type":"Feature","properties":{},"geometry":{"coordinates":[[[13.686614133428463,51.07615769535704],[13.686671101003753,51.0738510450835],[13.689892932130533,51.073823205494676],[13.689905591584761,51.07499643079419],[13.68853204079025,51.075000407778504],[13.68806680582854,51.07503023156097],[13.688024080162613,51.07616266132093],[13.686614133428463,51.07615769535704]]],"type":"Polygon"}}',
  },
};

export const BUFFER_AREA = 10;